import { Layout, Text } from '@loadsmart/miranda-react'

import { evaluatePasswordStrength } from '../domain/User'
import { PasswordCheckItem } from './PasswordCheckItem'

export type PasswordChecksProps = {
  password: string
}

export function PasswordChecks({ password }: PasswordChecksProps) {
  const { hasLength, hasNumber, hasSpecialChar, hasUpperCase, hasLowerCase } =
    evaluatePasswordStrength(password)

  const showIcon = Boolean(password)

  return (
    <Layout.Stack gap="spacing-4">
      <Text variant="body-md" color="color-text-tertiary">
        Your password must contain:
      </Text>
      <PasswordCheckItem showIcon={showIcon} isValid={hasLength} text="At least 8 characters" />
      <PasswordCheckItem showIcon={showIcon} isValid={hasNumber} text="At least one number" />
      <PasswordCheckItem
        showIcon={showIcon}
        isValid={hasSpecialChar}
        text="At least one special character"
      />
      <PasswordCheckItem
        showIcon={showIcon}
        isValid={hasUpperCase && hasLowerCase}
        text="Upper-case and lower-case letters"
      />
    </Layout.Stack>
  )
}
